// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".range-slider__vertical{width:16px;min-height:100%;height:100%;z-index:10;position:absolute;top:0;cursor:pointer}.range-slider__fill{display:none}.range-slider__handle{position:absolute;background-color:red;bottom:-8px;z-index:10;border-radius:10px;width:16px;height:16px;content:\" \"}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
